<template>
  <div class="region_container">
    <header>
      <h2 style="display: flex; justify-content: space-between; align-items: center">
        <span>{{ $t('region.title') }}</span>
        <a-button type="primary" @click="showRegionModal('COUNTRY')">{{ $t('buttons.add') }} {{ $t('customer.country') }}</a-button>
      </h2>
    </header>
    <div class="country_container" v-loading="isCountryLoading">
      <div class="country" v-for="(c, i) in countries" :key="c.name" @mousedown="selectedCountryId = c.id" :class="{ mgn: i % 4 === 0 }">
        <el-card>
          <a-dropdown :trigger="['contextmenu']">
            <h3 style="cursor: pointer;">{{ c.name }}</h3>
            <a-menu slot="overlay">
              <a-menu-item>
                <a href="javascript:;" @click="showRegionModal('COUNTRY', c)">{{ $t('buttons.edit') }}</a>
              </a-menu-item>
              <a-menu-item>
                <a href="javascript:;" @click="showRegionDeleteConfirm('COUNTRY', c.id)">{{ $t('buttons.delete') }}</a>
              </a-menu-item>
              <a-menu-item>
                <a href="javascript:;" @click="showRegionModal('PROVINCE', null, c)">{{ $t('buttons.add') }}{{ $t('customer.province') }}</a>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
          <a-tree
            style="margin-left: 15px;"
            :expanded-keys="c.expandedKeys"
            :auto-expand-parent="c.autoExpandParent"
            :tree-data="c.children"
            :replace-fields="replaceFields"
            @expand="onExpand"
          >
            <template slot="title" slot-scope="d">
              <a-dropdown :trigger="['contextmenu']">
                <span>{{ d.name }}</span>
                <a-menu slot="overlay">
                  <a-menu-item>
                    <a href="javascript:;" @click="showRegionModal(levelMap[d.level - 1].type, d, d.parent)">{{ $t('buttons.edit') }}</a>
                  </a-menu-item>
                  <a-menu-item>
                    <a href="javascript:;" @click="showRegionDeleteConfirm(levelMap[d.level - 1].type, d.id)">{{ $t('buttons.delete') }}</a>
                  </a-menu-item>
                  <a-menu-item v-if="d.level < 4">
                    <a href="javascript:;" @click="showRegionModal(levelMap[d.level].type, null, d)">{{ $t('buttons.add') }}{{ $t(`customer.${levelMap[d.level].t}`) }}</a>
                  </a-menu-item>
                </a-menu>
              </a-dropdown>
            </template>
          </a-tree>
        </el-card>
      </div>
    </div>
    <a-modal v-model="isRegionModalVisible" :title="modalTitle" :width="600" @ok="submitRegion" :confirmLoading="isSubmitting" :afterClose="clearRegionForm">
      <a-form-model ref="regionForm" :model="regionForm" :rules="regionRules" :label-col="{ span: 3 }" :wrapper-col="{ span: 20 }">
        <a-form-model-item :label="$t('customer.parent')" required v-show="formType !== 'COUNTRY'" prop="pid">
          <a-select v-model="regionForm.pid">
            <a-select-option v-for="p in parentList" :key="p.id">
              {{ p.name }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item :label="$t('linkage.name')" prop="name">
          <a-input v-model="regionForm.name" />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
import {
  getRegions,
  insertRegion,
  updateRegion,
  deleteRegion
} from '@/api/auth/ssq'

export default {
  data() {
    return {
      countries: [],
      isCountryLoading: false,
      selectedCountryId: '',
      replaceFields: {
        title: 'name'
      },
      formType: '',
      isRegionModalVisible: false,
      regionForm: {
        pid: 0,
        code: '',
        name: ''
      },
      regionRules: {},
      modalTitle: '',
      isSubmitting: false,
      parentList: [],
      levelMap: [
        {
          type: 'COUNTRY',
          t: 'country'
        },
        {
          type: 'PROVINCE',
          t: 'province'
        },
        {
          type: 'CITY',
          t: 'city'
        },
        {
          type: 'AREA',
          t: 'area'
        }
      ]
    }
  },
  computed: {
    lang() {
      return this.$store.state.lang
    }
  },
  watch: {
    lang: {
      immediate: true,
      handler() {
        this.translate()
      }
    }
  },
  mounted() {
    this.getRegionList()
  },
  methods: {
    translate() {
      this.regionRules = {
        name: [
          {
            required: true,
            message: this.$t('protocol.en')
          }
        ]
      }
    },
    onExpand(expandedKeys) {
      const country = this.countries.find(c => c.id === this.selectedCountryId)
      country.expandedKeys = expandedKeys
      country.autoExpandParent = false
      this.countries = [...this.countries]
    },
    async getRegionList() {
      this.isCountryLoading = true
      try {
        const { data } = await getRegions()
        for (let i = 0; i < data.length; i++) {
          this.setTreeData(data[i], '', 0, null)
        }
        let c
        this.countries = data.map(d => {
          c = this.countries.find(coun => coun.id === d.id)
          if (c) {
            d.expandedKeys = c.expandedKeys
          }
          return d
        })
        console.log(this.countries)
      } catch(e) {
        console.log(e)
      } finally {
        this.isCountryLoading = false
      }
    },
    setTreeData(target, key = '', level, parent) {
      target.parent = parent
      target.autoExpandParent = true
      target.scopedSlots = { name: 'name' }
      target.key = key ? (key + ' - ' + target.id) : target.id
      target.level = ++level
      if (target.children) {
        for (let i = 0; i < target.children.length; i++) {
          this.setTreeData(target.children[i], target.key, target.level, target)
        }
      }
    },
    addZero(target, dig) {
      let a = target.split('').reverse()
      console.log(a)
      for (let i = a.length; i < dig; i++) {
        a.push('0')
      }
      return a.reverse().join('')
    },
    showRegionModal(formType, record, reference) {
      this.formType = formType
      switch (formType) {
        case 'COUNTRY':
          this.modalTitle = this.$t('customer.country')
          if (record) {
            this.regionForm.code = record.code
            this.regionForm.name = record.name
            this.regionForm.id = record.id
          } else {
            this.regionForm.code = this.countries.length ? this.countries.at(-1).code * 1 + 1 + '' : '00'
            this.regionForm.code = this.addZero(this.regionForm.code, 2)
          }
          this.regionForm.pid = 0
          break
        case 'PROVINCE':
          this.modalTitle = this.$t('customer.province')
          if (record) {
            this.regionForm.code = record.code
            this.regionForm.name = record.name
            this.regionForm.id = record.id
            this.regionForm.pid = record.pid
          } else {
            this.regionForm.code = reference.children.length ? reference.children.at(-1).code * 1 + 1 + '' : '00'
            this.regionForm.code = this.addZero(this.regionForm.code, 2)
            this.regionForm.pid = reference.id
          }
          this.parentList = this.countries
          break
        case 'CITY':
          this.modalTitle = this.$t('customer.city')
          if (record) {
            this.regionForm.code = record.code
            this.regionForm.name = record.name
            this.regionForm.id = record.id
            this.regionForm.pid = record.pid
          } else {
            this.regionForm.code = reference.children.length ? reference.children.at(-1).code * 1 + 1 + '' : reference.code + '00'
            this.regionForm.pid = reference.id
            this.regionForm.code = this.addZero(this.regionForm.code, 4)
          }
          this.parentList = reference.parent.children
          break
        case 'AREA':
          this.modalTitle = this.$t('customer.area')
          if (record) {
            this.regionForm.code = record.code
            this.regionForm.name = record.name
            this.regionForm.id = record.id
            this.regionForm.pid = record.pid
          } else {
            this.regionForm.code = reference.children.length ? reference.children.at(-1).code * 1 + 1 + '' : reference.code + '00'
            this.regionForm.pid = reference.id
            this.regionForm.code = this.addZero(this.regionForm.code, 6)
          }
          this.parentList = reference.parent.children
      }
      this.isRegionModalVisible = true
    },
    submitRegion() {
      this.$refs.regionForm.validate(async valid => {
        if (valid) {
          this.isSubmitting = true
          try {
            if (this.regionForm.id) {
              const { message } = await updateRegion(this.formType, this.regionForm)
              this.$message.success(message)
            } else {
              const { message } = await insertRegion(this.formType, this.regionForm)
              this.$message.success(message)
            }
            this.isSubmitting = false
            this.isRegionModalVisible = false
            this.getRegionList()
          } catch(e) {
            console.log(e)
          } finally {
            this.isSubmitting = false
          }
        }
      })
    },
    clearRegionForm() {
      this.regionForm = {
        pid: 0,
        code: '',
        name: ''
      }
      this.formType = ''
    },
    showRegionDeleteConfirm(formType, id) {
      this.$confirm({
        title: this.$t('messages.ctrd'),
        content: this.$t('common.sd'),
        onOk: () => {
          return new Promise(async (resolve, reject) => {
            try {
              const { message } = await deleteRegion(formType, id)
              this.$message.success(message)
              this.getRegionList()
              resolve()
            } catch(e) {
              console.log(e)
              reject()
            }
          })
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.region_container {
  padding: 20px;
}
header {
  width: 100%;
}
.country_container {
  display: flex;
  flex-wrap: wrap;
  min-height: 500px;
  margin: 0 auto;
  h3 {
    font-weight: 600;
  }
  .country {
    width: calc(25% - 22.5px);
    margin-bottom: 15px;
    // margin-right: 30px;
    margin-left: 30px;
    &.mgn {
      margin-left: 0;
    }
    /deep/ .ant-tree {
      height: 680px;
      overflow: auto;
    }
  }
}
</style>